import React from "react";
import type { DownloadCell, DownloadLinkCell, DownloadTextCell } from "~/features/downloads/adapter";
import { useDownloads } from "~/features/downloads/context";
import { isContentVisible } from "~/features/downloads/visibility";
import { Button } from "~/features/ui/button";
import { CopyToClipboardText } from "~/features/ui/copy-to-clipboard-text";
import { Link } from "~/features/ui/link";
import ArrowRight from "~/public/icons/arrow-right.svg";
import ArrowTopRight from "~/public/icons/arrow-top-right.svg";
function DownloadCellText(props: {
  cell: DownloadTextCell;
}) {
  const {
    cell
  } = props;
  const {
    activeFirmwareVersion,
    activeHardwareVersion
  } = useDownloads();
  if (!isContentVisible(cell, activeHardwareVersion, activeFirmwareVersion)) {
    return null;
  }
  return <CopyToClipboardText text={cell.text} />;
}
function DownloadCellLink(props: {
  cell: DownloadLinkCell;
}) {
  const {
    cell
  } = props;
  const {
    activeFirmwareVersion,
    activeHardwareVersion
  } = useDownloads();
  if (!isContentVisible(cell, activeHardwareVersion, activeFirmwareVersion)) {
    return null;
  }
  const icon = cell.newWindow ? ArrowTopRight : ArrowRight;
  return <Button as={Link} variant="underline" href={cell.href} text={cell.text} newWindow={cell.newWindow} download={cell.download} icon={icon} />;
}
export function DownloadCellContent(props: {
  cell: DownloadCell;
}) {
  const {
    cell
  } = props;
  if (cell.kind === "text") {
    return <DownloadCellText cell={cell} />;
  }
  return <DownloadCellLink cell={cell} />;
}
export function DownloadCellList(props: {
  cells: DownloadCell[];
}) {
  return <>
      {props.cells.map((cell, idx) => <DownloadCellContent key={idx} cell={cell} />)}
    </>;
}